import { DeleteOutlined, EditOutlined, PlusOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { gql, useMutation } from "@apollo/client";
import { SchemesQueryProvider } from "__legacy/queries/schemes/SchemesQueryProvider";
import { Button, Input, Layout, notification, PageHeader, Popconfirm, Row, Space, Table, Tooltip } from "antd";
import { Fragment, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";

const deleteSchemeMutation = gql`
  mutation($id: ID!) {
    deleteScheme(id: $id) {
      scheme {
        id
        name
      }
    }
  }
`;

export const List: React.FC<{}> = () => {
  const navigate = useNavigate();

  const [searchQuery, setSearchQuery] = useState<string | null>(null);
  const handleSearch = (value: string) => setSearchQuery(value.trim());

  const [execDelete] = useMutation(deleteSchemeMutation, {
    errorPolicy: "none",
    onError: (error) => {
      notification.error({
        message: error.message,
      });
    },
    onCompleted: ({ deleteScheme: { scheme } }) => {
      notification.success({
        message: `Scheme "${scheme.name}" deleted`,
      });
    },
    refetchQueries: ["SchemesQuery"],
  });

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "schemes.name",
      render: (value: string, resource: any) => <NavLink to={resource.id}>{value}</NavLink>,
    },
    {
      title: "Kind",
      dataIndex: "kind",
    },
    {
      title: "Mandays Kind",
      dataIndex: "mandaysKind",
      render: (value: string) => value?.toUpperCase(),
    },
    {
      width: "80px",
      title: "Actions",
      dataIndex: "id",
      render: (id: string) => (
        <Row justify="end">
          <Space>
            <Tooltip title="Edit" placement="bottom">
              <Button onClick={() => navigate(`${id}/edit`)} icon={<EditOutlined />}></Button>
            </Tooltip>
            <Popconfirm
              title="Are you sure?"
              icon={<QuestionCircleOutlined />}
              onConfirm={() => execDelete({ variables: { id } })}
            >
              <Tooltip title="Delete" placement="bottom">
                <Button danger icon={<DeleteOutlined />}></Button>
              </Tooltip>
            </Popconfirm>
          </Space>
        </Row>
      ),
    },
  ];

  return (
    <SchemesQueryProvider variables={{ search: searchQuery }}>
      {({ schemes }) => (
        <Fragment>
          <PageHeader
            ghost={true}
            title="Schemes"
            extra={
              <Fragment>
                <Input.Search
                  allowClear
                  placeholder="search"
                  onSearch={handleSearch}
                  defaultValue={searchQuery ?? ""}
                  style={{ width: 500 }}
                />
                <Button onClick={() => navigate("new")} type="primary">
                  <PlusOutlined />
                  New
                </Button>
              </Fragment>
            }
          />
          <Layout.Content className="content">
            <Table rowKey="id" columns={columns} dataSource={schemes} pagination={false} />
          </Layout.Content>
        </Fragment>
      )}
    </SchemesQueryProvider>
  );
};
